export const domains = {
  mcdonald: "mcdonalds",
  lifearc: "lifearc",
};

export const getSubDomains = () => {
  return window.location.hostname.split(".")[0];
};
